import { WebApiAdaptor } from "@syncfusion/ej2-data";

export class CustomAdaptor extends WebApiAdaptor {
  processQuery(dm, query) {
    const original = super.processQuery(dm, query);

    const skipMatch = original.url.match(/[?&]\$skip=(\d+)/);
    const topMatch = original.url.match(/[?&]\$top=(\d+)/);
    const skip = skipMatch ? parseInt(skipMatch[1], 10) : 0;
    const top = topMatch ? parseInt(topMatch[1], 10) : null;

    original.url = original.url
      .replace(/[&?]\$inlinecount=[^&]*/g, "")
      .replace(/[&?]\$skip=[^&]*/g, "")
      .replace(/[&?]\$top=[^&]*/g, "");

    if (top !== null) {
      const pageNumber = Math.floor(skip / top) + 1;
      original.url = original.url
        .replace(/([?&])PageNumber=\d+/g, `$1PageNumber=${pageNumber}`)
        .replace(/([?&])PageSize=\d+/g, `$1PageSize=${top}`);
    }

    return original;
  }

  processResponse(response) {
    const data = response.items ?? [];
    const count = response.paging?.totalLines ?? response.totalLines ?? 0;
    return { result: data, count };
  }
}
